
export default {
  props: {
    item: Object,
    isNested: Boolean,
  },
};
